import { render, staticRenderFns } from "./BunCanvas.vue?vue&type=template&id=27e253c2"
import script from "./BunCanvas.vue?vue&type=script&lang=js"
export * from "./BunCanvas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports